import * as types from '../actions/ActionTypes';
import InitialState from './InitialState';
import * as BrokerTreeTypes from '../BrokerTreeTypes';
import { assign } from '../../../shared/Assign';

export default function brokerReducer(
    state: any = InitialState.brokers,
    action: { type: string; result: any }
) {
    switch (action.type) {
        case types.GET_BROKERTREE_SUCCESS:
        case types.UPDATE_BROKER_TREE: {
            const newState = assign({}, state);
            if (action.result.nodeId !== null && action.result.nodeId !== undefined) {
                let parent = findNode(newState.list, action.result.nodeId);
                parent.toggle = action.result.toggle === null ? true : !action.result.toggle;
                parent.children = parent.toggle === false ? null : action.result.list;
            } else {
                newState.list = action.result.list;
            }
            return newState;
        }

        case types.NEW_BROKER_CHAIN_SUCCESS:
        case types.NEW_BROKER_FIRMGROUP_SUCCESS:
        case types.NEW_BROKER_FIRM_SUCCESS:
        case types.NEW_BROKER_AGENT_SUCCESS: {
            const newState = assign({}, state);
            newState.new = action.result;
            newState.edit = {};
            return newState;
        }

        case types.ADD_BROKERTREE_SUCCESS:
        case types.CREATE_BROKER_CHAIN_SUCCESS:
        case types.CREATE_BROKER_FIRMGROUP_SUCCESS:
        case types.CREATE_BROKER_FIRM_SUCCESS:
        case types.CREATE_BROKER_AGENT_SUCCESS: {
            const newState = assign({}, state);
            newState.list = addNode(assign([], state.list), action.result.parentId, action.result);
            return newState;
        }

        case types.EDIT_BROKER_CHAIN_SUCCESS:
        case types.EDIT_BROKER_FIRMGROUP_SUCCESS:
        case types.EDIT_BROKER_FIRM_SUCCESS:
        case types.EDIT_BROKER_AGENT_SUCCESS: {
            const newState = assign({}, state);
            newState.edit = action.result;
            newState.new = {};
            return newState;
        }

        case types.UPDATE_BROKER_CHAIN_SUCCESS:
        case types.UPDATE_BROKER_FIRMGROUP_SUCCESS:
        case types.UPDATE_BROKER_FIRM_SUCCESS:
        case types.UPDATE_BROKER_AGENT_SUCCESS: {
            const newState = assign({}, state);
            newState.list = updateNode(
                assign([], newState.list),
                action.result.nodeId,
                action.result
            );
            return newState;
        }

        case types.MOVE_BROKERTREE_SUCCESS: {
            const newState = assign({}, state);
            let movedTree = assign([], newState.list);
            let movedItem: any = findNode(movedTree, action.result.id);
            movedItem.parentId = action.result.parentId;
            newState.list = moveNode(movedTree, movedItem, action.result.parentId);
            return newState;
        }

        case types.DELETE_BROKERTREE_SUCCESS: {
            const newState = assign({}, state);
            newState.list = removeNode(assign([], state.list), action.result);
            return newState;
        }

        case types.RESTORE_BROKERTREE_SUCCESS: {
            const newState = assign({}, state);
            newState.list = restoreNodes(assign([], state.list), action.result);
            return newState;
        }

        case types.LIST_BROKER_AGENT_SUCCESS: {
            const newState = assign({}, state);
            newState.tableList = assign({}, newState.tableList);
            newState.tableList.list = action.result.brokerAgents;
            newState.tableList.availableFirms = action.result.availableFirms;
            newState.tableList.allowedSites = action.result.allowedSites;
            return newState;
        }

        case types.CREATE_BROKER_LIST_AGENT_SUCCESS: {
            const newState = assign({}, state);
            newState.tableList = assign({}, newState.tableList);
            newState.tableList.list = [...newState.tableList.list, assign({}, action.result)];
            return newState;
        }

        case types.UPDATE_BROKER_LIST_AGENT_SUCCESS:
        case types.DELETE_BROKER_LIST_AGENT_SUCCESS:
        case types.RESTORE_BROKER_LIST_AGENT_SUCCESS: {
            const newState = assign({}, state);
            newState.tableList = assign({}, newState.tableList);
            newState.tableList.list = [
                ...newState.tableList.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;
        }

        default:
            return state;
    }
}

function findNode(nodes: any[], itemId: number) {
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === itemId) {
            return nodes[i];
        }

        if (nodes[i].children) {
            let item: any = findNode(nodes[i].children, itemId);

            if (item) {
                return item;
            }
        }
    }

    return null;
}

function addNode(nodes: any[], targetId: number, item: any) {
    if (!item.parentId) {
        nodes.push(item);
        return nodes;
    }

    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === targetId) {
            if (!nodes[i].children) {
                nodes[i].children = [];
            }

            nodes[i].children.push(item);
            nodes[i].toggle = true;
            nodes[i].hasChildren = true;
            break;
        } else if (nodes[i].children) {
            addNode(nodes[i].children, targetId, item);
        }
    }

    return nodes;
}

function updateNode(nodes: any[], id: number, item: any) {
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === id) {
            nodes[i].name = item.name;
            break;
        }

        if (nodes[i].children) {
            updateNode(nodes[i].children, id, item);
        }
    }

    return nodes;
}

function moveNode(tree: any[], item: any, parentId: number) {
    let newTree = deleteNode(tree, item.id);
    newTree = addNode(newTree, parentId, item);

    return newTree;
}

function deleteNode(nodes: any[], id: number) {
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === id) {
            nodes.splice(i, 1);
            break;
        }

        if (nodes[i].children) {
            deleteNode(nodes[i].children, id);
        }
    }

    return nodes;
}

function removeNode(nodes: any[], id?: number) {
    for (let i = 0; i < nodes.length; i++) {
        if (nodes[i].id === id || !id) {
            nodes[i].isRemoved = true;
            if (nodes[i].children) {
                removeNode(nodes[i].children);
            }
        }

        if (nodes[i].children) {
            removeNode(nodes[i].children, id);
        }
    }

    return nodes;
}

function restoreNodes(tree: any[], id: number) {
    let childNode = findNode(tree, id);
    if (childNode.isRemoved === true) {
        childNode.isRemoved = false;

        if (childNode.parentId) {
            restoreNodes(tree, childNode.parentId);
        }
    }

    return tree;
}
